// extracted by mini-css-extract-plugin
export default {"master-container":"g__master-container--_yUeS"};